/**
 * Function to get the initials of a user based on their username.
 *
 * @param {string} username - The username of the user.
 * @returns {string} - The initials of the user in uppercase.
 */
const getUserInitials = (username = '') => {
  const parts = username.split(/[.\s_-]+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return username.slice(0, 2).toUpperCase();
};

export default getUserInitials;
